import { createContext, useContext, useState, useMemo } from 'react';

const UIContext = createContext(null);

export const UIProvider = ({ children }) => {
  const [isKeyboardUser, setIsKeyboardUser] = useState(false);

  const value = useMemo(() => ({
    isKeyboardUser,
    setIsKeyboardUser
  }), [isKeyboardUser]);

  return (
    <UIContext.Provider value={value}>
      {children}
    </UIContext.Provider>
  );
};

export const useUI = () => {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error('useUI must be used within a UIProvider');
  }
  return context;
};
